module.exports = __webpack_public_path__ + "fonts/d08c09f.woff2";